import { render, staticRenderFns } from "./T1Stars.vue?vue&type=template&id=1ce12d7b&scoped=true&"
import script from "./T1Stars.vue?vue&type=script&lang=js&"
export * from "./T1Stars.vue?vue&type=script&lang=js&"
import style0 from "./T1Stars.vue?vue&type=style&index=0&id=1ce12d7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce12d7b",
  null
  
)

export default component.exports